// Sectors config with images (Unsplash placeholders — owner can replace via admin later).
// slug -> ordered image list (first is hero).
import { Building2, Cog, Truck, Sofa } from "lucide-react";

export const SECTORS = [
  {
    slug: "btp",
    icon: Building2,
    accent: "#FF3B30",
    hero: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1600607687644-c7171b42498f?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    ],
  },
  {
    slug: "industrial",
    icon: Cog,
    accent: "#003366",
    hero: "https://images.unsplash.com/photo-1565043666747-69f6646db940?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1581091012184-5c8c1b4b5b5a?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1590544644843-a9f9a71c1f9c?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1517420704952-d9f39e95b43e?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1581092160562-40aa08e78837?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    ],
  },
  {
    slug: "vehicles",
    icon: Truck,
    accent: "#FF6B00",
    hero: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1553440569-bcc63803a83d?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1568158879083-c42860933ed7?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1583121274602-3e2820c69888?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1613294326794-e7cff41b4b28?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    ],
  },
  {
    slug: "furniture",
    icon: Sofa,
    accent: "#10B981",
    hero: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1567016432779-094069958ea5?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1524758631624-e2822e304c36?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1519710164239-da123dc03ef4?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1540932239986-30128078f3c5?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1513694203232-719a280e022f?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
      "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    ],
  },
];

export const SECTOR_BY_SLUG = Object.fromEntries(SECTORS.map((s) => [s.slug, s]));
